import React from 'react';

export default function PirateHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Tricorn hat body */}
      <path d="M4 28C4 28 8 12 20 8C32 12 36 28 36 28Z" fill="#1A1A1A" />
      {/* Brim - three points */}
      <path d="M2 28C2 28 6 32 20 32C34 32 38 28 38 28L36 26C36 26 30 30 20 30C10 30 4 26 4 26Z" fill="#2C2419" />
      {/* Left point */}
      <path d="M4 26L2 28L8 28Z" fill="#1A1A1A" />
      {/* Right point */}
      <path d="M36 26L38 28L32 28Z" fill="#1A1A1A" />
      {/* Gold trim */}
      <path d="M8 26C12 24 16 22 20 22C24 22 28 24 32 26" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      {/* Skull */}
      <circle cx="20" cy="18" r="4" fill="#F5F5F0" />
      {/* Skull eyes */}
      <circle cx="18.5" cy="17.5" r="1" fill="#1A1A1A" />
      <circle cx="21.5" cy="17.5" r="1" fill="#1A1A1A" />
      {/* Skull nose */}
      <path d="M19.5 19L20 20L20.5 19" fill="#1A1A1A" />
      {/* Crossbones */}
      <line x1="14" y1="20" x2="26" y2="24" stroke="#F5F5F0" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="26" y1="20" x2="14" y2="24" stroke="#F5F5F0" strokeWidth="1.5" strokeLinecap="round" />
      {/* Bone ends */}
      <circle cx="14" cy="20" r="1" fill="#F5F5F0" />
      <circle cx="26" cy="20" r="1" fill="#F5F5F0" />
      <circle cx="14" cy="24" r="1" fill="#F5F5F0" />
      <circle cx="26" cy="24" r="1" fill="#F5F5F0" />
    </svg>
  );
}
